import { toTypedSchema } from "@vee-validate/zod";
import { z } from "zod";

const ConfirmPayment = z.object({
  terms: z.literal(true)
});

export type ConfirmPayment = z.infer<typeof ConfirmPayment>;

export const confirmPaymentValidator = toTypedSchema(ConfirmPayment);
